/**
 * Converts a schema object into a string that would be the
 * content for a file.
 * @param {object} schema
 * @param {string} moduleType Can be 'ES6', 'CommonJS' or 'JSON'. ES6 will mean
 * 'export default' will get appended at the front whereas CommonJS will be
 * 'module.exports =' and JSON will just be converted to a JSON string.
 * @returns {string}
 */
function convertSchemaToFileContent(schema, moduleType){
  var jsonContent = JSON.stringify(schema, null, 2)

  switch (moduleType){
    case 'ES6': return `export default ${jsonContent}`
    case 'CommonJS': return `module.exports = ${jsonContent}`
    default: return jsonContent
  }
}

export default convertSchemaToFileContent


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/Container/convertSchemaToFileContent.js